module.exports = __webpack_public_path__ + "static/media/ger.882de111.png";